import storeModule from '../store-module'
import { defineStore } from 'pinia'

const url = 'base-change-configs'

export default defineStore(
  'base-change-configs',
  storeModule.createStoreModule('base-change-configs', {
    fetchSingleURL: url,
    updateURL: url
  })
)
